<template>
	<div class="newsletter" v-if="En">
        <div class="newsletter1">Newsletter</div>
        <div class="newsletter2">You read this far，might as well subscribe.</div>
        <div class="newsletter3">
            <el-input v-model="val" placeholder="Please enter your email"></el-input>
            <div class="btn" @click="submit">Submit</div>
        </div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
    name: "newsletter",
    data() {
        return {
            val: ''
        };
    },
    created() {
    },
    methods: {
        submit() {
            if (!this.val) {
                this.$message.error('Please enter the email')
                return
            }
            const params = {
                email: this.val
            }
            protal.webSubscribeadd(params).then(res => {
                if (res.code === '0000') {
                    this.$message.success('Subscription successful')
                    this.val = ''
                }
            })
        }
    },
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
    .newsletter {
        padding: 80px 0;

        .newsletter1 {
            font-family: Inter, syn;
            font-weight: 400;
            font-size: 16px;
            color: #F4501C;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
        }

        .newsletter2 {
            font-family: Inter, syn;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            margin: 20px 0 26px;
        }

        .newsletter3 {
            display: flex;
            align-items: flex-end;

            /deep/ .el-input__inner {
                background: none;
                border: none;
                outline: none !important;
                border-bottom: 1px solid rgba(255, 255, 255, 0.4);
                border-radius: 0;
                font-family: Inter, syn;
                font-weight: 400;
                font-size: 22px;
                color: #FFFFFF !important;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                padding: 0;
            }
            
            .btn {
                margin-left: 15px;
                width: 140px;
                height: 52px;
                background: rgba(255, 255, 255, 0.15);
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Inter, syn;
                font-weight: 400;
                font-size: 22px;
                color: #FFFFFF;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                cursor: pointer;

                &:hover {
                    background-color: #F4501C;
                }
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .newsletter {
        width: 6.78rem;
        margin: 0 auto;
        padding: .8rem 0;

        .newsletter1 {
            font-family: Inter, syn;
            font-weight: 400;
            font-size: .24rem;
            color: #F4501C;
            line-height: .24rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
        }

        .newsletter2 {
            font-family: Inter, syn;
            font-weight: 400;
            font-size: .28rem;
            color: #FFFFFF;
            line-height: .28rem;
            text-align: left;
            font-style: normal;
            margin: .24rem 0 .4rem;
        }

        .newsletter3 {
            display: flex;
            align-items: flex-end;

            /deep/ .el-input__inner {
                background: none;
                border: none;
                outline: none !important;
                border-bottom: 1px solid rgba(255, 255, 255, 0.4);
                border-radius: 0;
                font-family: Inter, syn;
                font-weight: 400;
                font-size: .26rem;
                color: #FFFFFF !important;
                text-align: left;
                font-style: normal;
                padding: 0;
            }
            
            .btn {
                margin-left: .08rem;
                width: 1.6rem;
                height: .8rem;
                background: rgba(255, 255, 255, 0.15);
                border-radius: .12rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Inter, syn;
                font-weight: 400;
                font-size: .24rem;
                color: #FFFFFF;
                line-height: .24rem;
                text-align: left;
                font-style: normal;
                cursor: pointer;

                &:hover {
                    background-color: #F4501C;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/newsletter.vue